import type { IChat } from '@/modules/chat-matrix-fast/types/IChat'

export function isDialogChatType(type: IChat['type'] | undefined): boolean {
  return type === 'dialog' || type === 'direct'
}

/** MXID собеседника: Matrix room → backend dialog_member */
export function resolveDialogPeerMxid(
  chat: Pick<IChat, 'type' | 'matrix_peer_id' | 'dialog_member'>,
): string | null {
  if (!isDialogChatType(chat.type)) {
    return null
  }

  const fromPeer = chat.matrix_peer_id?.trim()
  if (fromPeer?.startsWith('@')) {
    return fromPeer
  }

  const fromMember = chat.dialog_member?.matrix_user_id?.trim()
  if (fromMember?.startsWith('@')) {
    return fromMember
  }

  return null
}

export function chatMatchesPeerMxid(
  chat: Pick<IChat, 'type' | 'matrix_peer_id' | 'dialog_member'>,
  mxid: string,
): boolean {
  return resolveDialogPeerMxid(chat) === mxid.trim()
}

export function collectDialogPeerMxids(
  chats: Array<Pick<IChat, 'type' | 'matrix_peer_id' | 'dialog_member'>>,
): string[] {
  return [...new Set(
    chats
      .map(chat => resolveDialogPeerMxid(chat))
      .filter((mxid): mxid is string => Boolean(mxid)),
  )]
}
